<script>
  import { loadingStore, navStore } from '../stores/General';
  import { Link } from 'svelte-navigator';
  import CustomIcon from '../components/CustomIcon.svelte'
  import config from '../assets/config';

  export let showMenuText = true;
  // console.log(`Env: ${config.environment}`);
  const productionExclude = config.environment === "Production" ? ["campaigns","report"] : []

  const aSelectedClasses =
    'h-14 mx-4 my-2 px-4 py-4 bg-custom-orange text-white group flex items-center px-2 py-2 text-lg font-medium rounded-md';
  const aClasses =
    'h-14 mx-4 my-2 px-4 py-4 text-black hover:bg-gray-100 hover:text-gray-900 group flex items-center px-2 py-2 text-lg font-medium rounded-md';
  const svgSelectedClasses = 'text-white-500 mr-4 shrink-0 h-6 w-6';
  const svgClasses =
    'text-gray-400 group-hover:text-gray-500 mr-4 shrink-0 h-6 w-6';

  let onClick = (item) => {
    navStore.Select(item);
    loadingStore.off()
  };
</script>

<nav class="mt-5 space-y-1 h-full flex flex-col justify-between">
  <div>
    {#each $navStore.items as item (item.key)}
      {#if !productionExclude.includes(item.key)}
        <Link to={item.path} class="hover:no-underline">
          <!-- Current: "bg-gray-100 text-gray-900", Default: "text-gray-600 hover:bg-gray-50 hover:text-gray-900" -->
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div
            class={item.key == $navStore.selected?.key ? aSelectedClasses : aClasses}
            class:w-14={!showMenuText}
            on:click={() => onClick(item)}
          >
        
            <!--
          Heroicon name: outline/home

          Current: "text-gray-500", Default: "text-gray-400 group-hover:text-gray-500"
        -->
        
            <div class="mr-1">
              <CustomIcon  name={item.key} color= {item.key == $navStore.selected?.key
              ? 'white'
              : '#9A9AB0'}/>
            
            </div>
            {#if showMenuText}
              {item.label}
            {/if}
          </div>
        </Link> 
      {/if}
    {/each}
  </div>
</nav>
